<template>
  <v-row no-gutters>

    <v-col cols="12" style="position: relative;">
      <div class="title">Inputs</div>
      <v-row>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="policyEoyCashValue"
            outlined
            label="End Of Year Cash Value"
            placeholder="$"
            @focus="makeDollarEditable('policyEoyCashValue', $event)"
            @blur="formatDollar('policyEoyCashValue', $event)"
          />
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="policyCashIncrease"
            outlined
            label="Cash Value Increase"
            placeholder="$"
            @focus="makeDollarEditable('policyCashIncrease', $event)"
            @blur="formatDollar('policyCashIncrease', $event)"
          />
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="policyLoan"
            outlined
            label="Loan Balance"
            placeholder="$"
            :error-messages="(exceedsMaxLoan ? ['Maximum Loan Amount is ' + $options.filters.currencyRounded(maxLoan)] : [])"
            :hint="'Maximum Loan Amount is ' + $options.filters.currencyRounded(maxLoan)"
            persistent-hint
            @focus="makeDollarEditable('policyLoan', $event)"
            @blur="formatDollar('policyLoan', $event)"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2" style="position: relative;">
      <v-row>
        <v-col cols="12" md="6" class="enhancerSummaryBox">
          <div class="title">Daily Cash Growth</div>
          <div class="enhancerFormula"></div>
          <v-card color="primary">
            <v-card-text>
              <v-row no-gutters class="flex-column">
                <v-col class="text-center enhancerFormula white--text mb-3">
                  <strong>{{ cashIncrease | currencyRounded }} / 365 Days</strong>
                </v-col>
                <v-col class="text-center display-1 white--text">
                  {{ dailyCashIncrease | currency }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="6" class="enhancerSummaryBox">
          <div class="title">Daily Interest Charge</div>
          <div class="enhancerFormula">Total Interest = {{ loan | currencyRounded }} * {{ loanInterestRate | numberRounded }}% = {{ loanInterest | currencyRounded }}</div>
          <v-card color="error">
            <v-card-text>
              <v-row no-gutters class="flex-column">
                <v-col class="text-center enhancerFormula white--text mb-3">
                  <strong>{{ loanInterest | currencyRounded }} / 365 Days</strong>
                </v-col>
                <v-col class="text-center display-1 white--text">
                  {{ dailyLoanInterest | currency }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        
      </v-row>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: 'WealthEnhancer',
  data: () => ({
    policyEoyCashValue: null,
    policyCashIncrease: null,
    policyLoan: null,
    loanInterestRate: 5
  }),
  computed: {
    eoyCashValue() {
      return this.$root.getNumber(this.policyEoyCashValue)
    },
    cashIncrease() {
      return this.$root.getNumber(this.policyCashIncrease)
    },
    loan() {
      return this.$root.getNumber(this.policyLoan)
    },
    maxLoan() {
      return this.eoyCashValue * .9
    },
    exceedsMaxLoan() {
      return this.loan > this.maxLoan
    },
    dailyCashIncrease() {
      return this.cashIncrease / 365
    },
    loanInterest() {
      return this.loan * (this.loanInterestRate / 100)
    },
    dailyLoanInterest() {
      return this.loanInterest / 365
    }
  },
  methods: {
    formatDollar(field, e) {
      let value = e.srcElement.value
      if(value) {
        let formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        })
        value = formatter.format(value)
      } else {
        value = null
      }
      this[field] = value
    },
    makeDollarEditable(field, e) {
      let value = e.srcElement.value
      let cleaned = ('' + value).replace(/[^0-9.-]/g, '')
      this[field] = cleaned
    },
  }
}
</script>

<style lang="scss" scoped>
  
  .enhancerFormula {
    height: 25px;
    font-family:'Courier New', Courier, monospace !important
  }
  
</style>